import React from 'react'
import { ScrollReveal } from '../ui/scroll-reveal'
import { Zap, Clock, Users, FlaskConical, Map, Shield, Workflow } from 'lucide-react'

export function BenefitsSection() {
  return (
    <section className="relative py-20 bg-gradient-to-b from-background to-background/95">
      <div className="container relative space-y-12">
        <ScrollReveal>
          <div className="text-center space-y-4 max-w-3xl mx-auto">
            <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
              What You Get
            </h2>
            <p className="text-lg text-muted-foreground font-light">
              Working AI systems, not just strategy documents
            </p>
          </div>
        </ScrollReveal>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {[
            {
              title: "Working AI, Not Just a Report",
              description: "You finish with a deployed Partner AI that's already proving value - not a strategy document that sits on a shelf.",
              icon: Zap,
              delay: 0.1
            },
            {
              title: "Consultant-Led, Not Self-Serve",
              description: "Experienced consultants work directly with your people - capturing knowledge properly, not hoping uploaded documents will be enough.",
              icon: Users,
              delay: 0.2
            },
            {
              title: "Focused Proof of Value",
              description: "We target one area of your business, prove it works, then you decide whether to scale. Lower risk than enterprise-wide rollouts.",
              icon: FlaskConical,
              delay: 0.3
            },
            {
              title: "Knowledge That Transfers",
              description: "Everything we build belongs to you. Your teams learn to maintain and evolve the systems - no ongoing dependency on us.",
              icon: Map,
              delay: 0.4
            },
            {
              title: "Enterprise-Ready Security",
              description: "Partner AIs deployed on SOC 2 Type II, ISO 27001 and GDPR-compliant platforms. Human-in-the-loop workflows for sensitive environments.",
              icon: Shield,
              delay: 0.5
            },
            {
              title: "Foundation for Scaling",
              description: "The Knowledge Architecture and Partner AI become templates. Expanding to other business areas gets faster and cheaper.",
              icon: Workflow,
              delay: 0.6
            }
          ].map((benefit, index) => (
            <ScrollReveal key={index} delay={benefit.delay}>
              <div className="relative overflow-hidden rounded-xl border border-primary/10 bg-background/95 backdrop-blur-sm shadow-sm p-6">
                <div className="flex flex-col items-center text-center space-y-3">
                  <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                    <benefit.icon className="h-7 w-7 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-medium">{benefit.title}</h3>
                  <p className="text-sm text-muted-foreground">{benefit.description}</p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  )
}
